module.exports = __webpack_public_path__ + "static/media/petsandanimals.bf9f14d1.jpg";